<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <rect width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect x="4" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect x="8" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect y="4" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect x="4" y="4" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect x="8" y="4" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect y="8" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect x="4" y="8" width="2" height="2" rx="1" fill="#1F1F1F"/>
  <rect x="8" y="8" width="2" height="2" rx="1" fill="#1F1F1F"/>
</svg>